import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetTransferService } from '../../services/asset-transfer.service';
import { AssetService } from '../../services/asset-service';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { AssetTransfer } from '../../models/entities/asset-transfer';
import { SecurityService } from 'src/app/security/services/security-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetTransferLine } from '../../models/entities/asset-transfer-line';
import { ProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/product-category-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { AssetTransferPipe } from '../../pipes/asset-transfer-pipe';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { AssetTransferDirection } from '../../enums/asset-transfer-direction';
import { AssetTransferType } from '../../enums/asset-transfer-type';


@Component({
    selector: 'asset-assignment-widget-mobile',
    templateUrl: './asset-assignment-widget-mobile.component.html',
    styleUrls: ['./asset-assignment-widget-mobile.component.scss']
})

export class AssetAssignmentWidgetMobileComponent extends BaseWidget {
  
  @Input() direction          : string;


  productCategories           : ProductCategory[];

  assetTransfer               : AssetTransfer;
  assetTransferAssetColumns   = [];
  assignmentsChange           : boolean = false;
  branchs                     : Branch[] = null;

  acceptanceMode              : string = "A";

  missingBarCodes             : number = 0;
  serialNumber                : string;
  barCode                     : string;
  serialNumberCheched         : boolean = false;
  title                       : string = "Affectations Client"
  validateButtonLabel         : string = "Valider";


  constructor(
    protected controlTablesService: ControlTablesService,
    protected assetTransferService: AssetTransferService,
    protected assetService        : AssetService,
    protected toastr              : ToastrService,
    protected security            : SecurityService,
    public userService         : UserService,
    protected networkService      : LeanNetworkService,
    public    leanUtilsService    : LeanUtilsService) {
    super(toastr, leanUtilsService);
 }

  ngOnInit(){
    
    super.ngOnInit();


    this.controlTablesService.branchsGet().then(branchs => {
      this.branchs = branchs; 

          let isNew  : boolean = false;
          let toBranch = null;
          let partner = null;
          if (! this.assetTransfer.assetTransferCode){
            isNew = true;
            toBranch = this.assetTransfer.toBranch;
            partner = this.assetTransfer.partner;
          }
      
          this.assetTransferService.assetTransferGet(this.assetTransfer.assetTransferCode).then(result => {
            this.assetTransfer  = result;
            if (isNew){
              this.assetTransfer.toBranch =  toBranch;
              this.assetTransfer.partner =  partner;
              this.assetTransfer.edit = true; 
            }
            this.processAssetTransfer();
          })

    })

    if (this.assetTransfer.assetTransferType == AssetTransferType.Reception) {
      this.title = "Réception fournisseur";
    }

    if (this.assetTransfer.assetTransferType == AssetTransferType.Transfer) {
      if (this.direction == AssetTransferDirection.output) {
        this.title = "Expédition Agence";
        this.validateButtonLabel = "Valider Expédition";
      } else {
        this.title = "Réception Agence";
        this.validateButtonLabel = "Valider Réception";
      }
    }
   
    if (this.assetTransfer.assetTransferType == AssetTransferType.Assignment) {
      if (this.direction == AssetTransferDirection.output) {
        this.title = "Affectation client";
        this.validateButtonLabel = "Valider Affectation";
      } else {
        this.title = "Retour client";
        this.validateButtonLabel = "Valider Retour";
      }
    }

  }
      

  //------------------------------------------------------
  setEntity(assetTransfer: AssetTransfer) {
      this.assetTransfer = { ...assetTransfer };
  }
  getEntity(){
      return this.assetTransfer;
  }
  //------------------------------------------------------
  
  //------------------------------------------------------
  saveRow() : Promise<AssetTransfer>{
    if (this.assetTransfer.assetTransferLines){
      for (let atl of this.assetTransfer.assetTransferLines){
        if (atl.quantity <0) {
          this.toastr.error("Quantité négattive non autorisée");
          return;
        }
      }
    }
    return this.assetTransferService.assetTransferSave(this.assetTransfer);
  }

  afterValidate(){
    this.processAssetTransfer();
    this.assignmentsChange  = false;
  }
  //------------------------------------------------------


  processBarcode(assetTransferLine : AssetTransferLine){
    if (this.assetTransfer.expeditionModeEnabled) {
      this.addAsset(assetTransferLine);
      return;
    }

    if (this.assetTransfer.receptionModeEnabled) {
      this.acceptAsset(assetTransferLine);
      return;
    }

  }

  acceptAsset(assetTransferLine : AssetTransferLine){
    let foundAsset : Asset = null;
    for  (let asset  of assetTransferLine.assets){
        if(asset.barCode == assetTransferLine.barCode) {
          foundAsset = asset; 
          break;
        }
    }

    if (foundAsset == null){
      this.toastr.error("Code à barres inexistant dans la liste ");
      return;
    }
    assetTransferLine.barCode = null;
    foundAsset.rejected = (this.acceptanceMode != "A");

    this.processAssetTransferLine(assetTransferLine);

  }



  addAsset(assetTransferLine : AssetTransferLine){
    if (! assetTransferLine.barCode){
      this.toastr.error("Prière de scanner un code à barres");
      return;
    }

    assetTransferLine.barCode = assetTransferLine.barCode.trim()
    if (assetTransferLine.barCode == ""){
      this.toastr.error("Prière de scanner un code à barres");
      return;
    }
  
    
    if ( (this.leanUtilsService.barCodelength) && (assetTransferLine.barCode.length != this.leanUtilsService.barCodelength)) {
      this.toastr.error("Longueur du code à barres invalide");
      return;
    }
    
  
    for (let asset of assetTransferLine.assets) {
        if (asset.barCode == assetTransferLine.barCode) {
          this.toastr.error("Ce code à barres est déjà affecté à ce transfert");
          return;
        }
    }

    let asset: Asset = new Asset();
    asset.barCode = assetTransferLine.barCode;
    assetTransferLine.barCode = null;
    assetTransferLine.assets.push(asset);
    this.assignmentsChange = true;
  }


  remove(assetTransferLine : AssetTransferLine, asset : Asset){
    const index = assetTransferLine.assets.indexOf(asset, 0);
    if (index > -1) {
      assetTransferLine.assets.splice(index, 1);
      this.assignmentsChange = true;
    }
  }


  assetTransferLinkAssets(){
    this.assetTransferService.assetTransferLinkAssets(this.assetTransfer).then(assetTransfer => {
      this.assetTransfer = assetTransfer; 
      this.processAssetTransfer();
      this.assignmentsChange  = false;
      this.toastr.success("Opération effectuée avec succès")
    })
  }



  receptionable()  : boolean {
    return this.assetTransfer.receptionModeEnabled;
  }

  
  expiditionable()  : boolean {
    if (this.editMode() != 'R') {
      return false;
    }
    return this.assetTransfer.expeditionModeEnabled;
  }


  assetTransferValidate(){

    if (this.receptionable()) {
      this. assetTransferValidateReception();
      return;
    } 

    if (this.expiditionable()) {
      this.assetTransferValidateExpedition();
      return;
    }

  }


  assetTransferValidateExpedition(){
    this.assetTransferService.assetTransferValidateExpedition(this.assetTransfer.assetTransferCode).then(assetTransfer => {
      this.assetTransfer = assetTransfer; 
      this.processAssetTransfer();
    })
  }

  
  assetTransferValidateReception(){
    let unprocessed = 0;
      this.assetTransfer.assetTransferLines.forEach(atl => {
        atl.assets.forEach(asset => {
            if (asset.rejected == undefined){
              unprocessed++
            }
        })
      })

      if (unprocessed > 0) {
        this.toastr.error("Nbre de frigos non traités : " + unprocessed);
        return;
      }

      this.assetTransferService.assetTransferValidateReception(this.assetTransfer).then(assetTransfer => {
        this.assetTransfer = assetTransfer; 
        this.processAssetTransfer();
      })
  }

  
  assetTransferRegisterReception(){
    this.assetTransferService.assetTransferRegisterReception(this.assetTransfer).then(result => {
      this.toastr.success("Opération effectuée avec succès");
    })
  }



  serialNumberEntered(){
    this.barCode = null;
    this.checkSerialNumber();
  }

  checkSerialNumber() : boolean{
    this.serialNumberCheched = false;
    if (! this.serialNumber){
      this.toastr.error("N° Série vide");
      return false;
    }
    if (this.serialNumber.trim() == ""){
      this.toastr.error("N° Série vide");
      return false;
    }
    if (  (this.leanUtilsService.serialNumberlength) &&  (this.serialNumber.length != this.leanUtilsService.serialNumberlength) ) {
      this.toastr.error("Longueur du N° Série invalide");
      return false;
    }
    this.serialNumberCheched = true;
    return true;
  }


  barCodeEntered(){
    if ( !this.checkSerialNumber()){
        return;
    }

    if ( (this.leanUtilsService.barCodelength) && (this.barCode.length != this.leanUtilsService.barCodelength)){
      this.toastr.error("Longueur du code à barres invalide");
      return;
    }

    let foundAsset : Asset = null;
    for (let atl of this.assetTransfer.assetTransferLines){
      for (let asset of atl.assets){
        if (asset.serialNumber == this.serialNumber){
            foundAsset = asset;
        }
        if ( (asset.barCode == this.barCode) && (asset.serialNumber != this.serialNumber)){
          this.toastr.error("Ce code à barres est déjà associé à un frigo");
          return;
        }
      }
    }

    if (! foundAsset ) {
      this.toastr.error("Pas de frigos avec  de N° Série");
      return;
    }

    this.assetService.assetBarCodeSet(foundAsset.assetCode, this.barCode) .then(result => {
      foundAsset.barCode = this.barCode;
      this.serialNumber         = null;
      this.barCode              = null;
      this.serialNumberCheched  = false;

      this.processAssetTransfer();
    })

  }


  processAssetTransfer(){

    //--  Missing Bar Codes Calculation ------------------------------------
    this.missingBarCodes = 0;
    for (let atl of this.assetTransfer.assetTransferLines){

      this.processAssetTransferLine(atl);

      for (let asset of atl.assets){
        if (asset.assetCode == asset.barCode){
            this.missingBarCodes++;
        }
      }
    }
    //--------------------------------------------------------------
 


  }


  processAssetTransferLine(assetTransferLine : AssetTransferLine){
    assetTransferLine.acceptedAssetsNumber = 0;
    assetTransferLine.rejectedAssetsNumber = 0;
    for  (let asset  of assetTransferLine.assets){
      if(asset.rejected != undefined) {
        if(asset.rejected) {
          assetTransferLine.rejectedAssetsNumber++;
        } else {
          assetTransferLine.acceptedAssetsNumber++;
        }
      }
    }
  }

  assetCallsCountGet(){
    this.assetTransferService.assetCallsCountGet(this.assetTransfer.toBranch.branchCode).then(productCategories => {
      this.productCategories = productCategories; 
    })
  }


  assetTransferPipe  : AssetTransferPipe = new AssetTransferPipe(); 
      getAssetTransferStatus() : string{
    return this.assetTransferPipe.transform(this.assetTransfer, 'progressLevel');
  }

}